// map-trajectory 编辑器：title/subtitle/theme + checkpoints(name/desc/坐标) 增删。
import { useTranslation } from 'react-i18next'
import type { EditorContext } from '../_shared/types'
import type { MapData, MapTheme } from './types'
import { Field, TextInput, SelectInput, CoordField, Repeater, RemoveButton } from '../../components/editor-controls'

const MAP_THEMES: Record<MapTheme, [string, string]> = {
  gold: ['#f59e0b', '#fbbf24'],
  aurora: ['#06b6d4', '#10b981'],
  ember: ['#ef4444', '#f97316'],
  cosmic: ['#8b5cf6', '#ec4899'],
}
const MAP_THEME_IDS: MapTheme[] = ['gold', 'aurora', 'ember', 'cosmic']

export function MapTrajectoryEditor({ data, update }: EditorContext) {
  const { t } = useTranslation()
  const d = data as unknown as MapData
  const cities = d.cities || []
  return (
    <>
      <Field label={t('editor.journeyTitle')}>
        <TextInput value={d.title ?? ''} onChange={(v) => update((dd) => { dd.title = v })} />
      </Field>
      <Field label={t('editor.subtitle')}>
        <TextInput value={d.subtitle ?? ''} onChange={(v) => update((dd) => { dd.subtitle = v })} />
      </Field>
      <Field label={t('editor.routeTheme')}>
        <div className="theme-row">
          {MAP_THEME_IDS.map((th) => (
            <div
              key={th}
              className={`theme-chip${d.theme === th ? ' active' : ''}`}
              style={{ background: `linear-gradient(135deg, ${MAP_THEMES[th][0]}, ${MAP_THEMES[th][1]})` }}
              onClick={() => update((dd) => { dd.theme = th })}
            >
              <span>{th}</span>
            </div>
          ))}
        </div>
      </Field>
      <Field label={t('editor.mapRegion')}>
        <SelectInput
          value={(d.mapRegion || 'world') as string}
          onChange={(v) => update((dd) => { dd.mapRegion = v })}
          options={['world', 'china', 'europe', 'north-america', 'asia']}
        />
      </Field>
      <Field label={t('editor.checkpointsCount', { count: cities.length })}>
        {cities.map((c, i) => (
          <div className="editable-item col" key={i}>
            <div className="editable-item">
              <span className="ei-rank">{i + 1}</span>
              <TextInput
                value={c.name}
                placeholder={t('editor.cityPh')}
                style={{ flex: 1 }}
                onChange={(v) => update((dd) => { dd.cities[i].name = v })}
              />
              <RemoveButton onRemove={() => update((dd) => { dd.cities.splice(i, 1) })} />
            </div>
            <TextInput
              value={c.desc}
              placeholder={t('editor.descPh')}
              onChange={(v) => update((dd) => { dd.cities[i].desc = v })}
            />
            <CoordField
              lng={c.lng}
              lat={c.lat}
              onLng={(v) => update((dd) => { dd.cities[i].lng = v })}
              onLat={(v) => update((dd) => { dd.cities[i].lat = v })}
            />
          </div>
        ))}
        <Repeater
          addLabel={t('editor.city')}
          onAdd={() => update((dd) => { dd.cities.push({ name: '', lng: 0, lat: 0, desc: '' }) })}
        />
      </Field>
    </>
  )
}
